module.exports = __webpack_public_path__ + "0fd3985735316b65cc8102dbaef4c5a4.svg";